// extracted by mini-css-extract-plugin
export default {"muiSelectBox":"MuiSelectBox_muiSelectBox__XOH3X"};